var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0102 5.04842L5.04873 21.0098C4.10192 21.9567 2.58678 21.9784 1.66674 21.0583C0.746701 20.1383 0.768432 18.6232 1.71525 17.6764L17.6767 1.71493C18.6235 0.768114 20.1386 0.746382 21.0587 1.66642C21.9787 2.58647 21.957 4.1016 21.0102 5.04842Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6772 21.015L1.71575 5.05362C0.768931 4.1068 0.7472 2.59167 1.66724 1.67163C2.58728 0.751583 4.10242 0.773314 5.04923 1.72013L21.0107 17.6816C21.9575 18.6284 21.9792 20.1435 21.0592 21.0635C20.1391 21.9836 18.624 21.9619 17.6772 21.015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.7fd655e0afe81c357b37c3d2a716a690.svg";
export { ForwardRef as ReactComponent };